<template>
  
  <div>

    <div class="wrapper__inner--narrow">
      <section :class="pageCss">
        <img :src="content.image" :alt="content.alt">
      </section>
    </div>
  </div>

</template>

<script>

  export default {
    name: 'SectionImage',
    props: {
      content: {
        type: Object,
        required: true,
        default: () => {}
      }
    },
    computed: {

      pageCss() {
        return `content content__${this.content.type}`;
      },

    }
  };
</script>